import { Component, Input } from '@angular/core';
import { shortTx } from 'src/app/shared/utils/impact-panel.utils';

@Component({
  selector: 'app-tx-link',
  templateUrl: './tx-link.component.html',
  styleUrls: ['./tx-link.component.scss'],
})
export class TxLinkComponent {
  @Input() txHash?: string | null;
  @Input() explorerUrl?: string | null;

  get shortHash(): string {
    return shortTx(this.txHash);
  }
}
